const headers = {
  name: "Supplier Outstanding Statement",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by PO number or supplier",
      value: "",
    },
    {
      type: "range",
      name: "date",
      placeholder: ["Start Date", "End Date"],
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Suppliers",
        path: "/app/suppliers",
      },
      {
        name: "Outstanding Statement",
        path: "",
      },
    ],
  },
};

export default headers;